export default function BlurredCircle() {
  return (
    <div className="-z-10 w-[162px] h-[162px] bg-webPrimary rounded-full blur-[100px] absolute top-0 left-[50%] -translate-x-[50%]"></div>
  );
}
